import { accordionInit } from "../lib/accordion.js";
import { onDocumentLoaded } from "../utils/on-document-loaded.js";
import { storesSlider } from "../modules/retail/stores-slider.js";
import { feedbackSlider } from "../modules/retail/feedback-slider.js";

onDocumentLoaded(() => {
    console.log("[retail-page.js inited]");
    accordionInit();
    storesSlider();
    feedbackSlider();
});